export const locale = {
    lang: 'en',
    data: {
        CUSTOMER_SHORT_INFO_CARD: {
            TITLES: {
                LIKED: ' liked',
                NM: ' new matches',
                APPOINTMENTS: ' appointments',
                MESSAGES: ' messages',
            },
        }
    }
};